import React from "react";
import Chart from "../Components/chart";
import Container from "react-bootstrap/Container";
import {Col, Row} from "react-bootstrap";

function statistic(){

    return (
        <Container >
            <Row>
                <Col>
                    <Chart/>
                </Col>
            </Row>
        </Container>
    );
}

export default statistic;